<template>
    
    <svg width="43" height="38" viewBox="0 0 43 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse opacity="0.9" cx="21.4441" cy="18.7353" rx="21.1082" ry="18.4697" :fill="color"/>
</svg>

</template>

<script>
export default {
	name: 'left_knee_b',

	props: {
		// Color or hex code
		color: {
			type: String
		}
	}
}
</script>